import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface IBookingLockCheckedPayload {
  correlationId: string,
  deviceName?: string,
  isLocked: boolean
}

export class BookingLockCheckedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'BookingLockCheckedPayload';

  constructor(public readonly payload: IBookingLockCheckedPayload) {
  }
}
